kv.controller('CustomerDueInvoicesReportShowCtrl', function($scope, $element, $attrs, $http, resource, $filter, $uibModal, $rootScope, $injector) {
    var vm = new baseCtrl($scope, $element, $attrs, $injector, $filter);
    var params = kvUtils.getAllQueryParams();
    
    if (params) {
        if (params.generate) {
            $('[href="#results-tab"]').tab("show");
        }
    }

    $(document).ready(function () {

        $('#table-search').on('keyup', function () {
            var value = $.trim($(this).val()).toLowerCase();

            // show everything if search empty
            if (!value) {
                $('#table tbody tr').show();
                return;
            }

            var $rows = $('#table tbody tr');
            var currentGroupRow = null;
            var groupHasVisibleRows = false;

            $rows.each(function () {
                var $row = $(this);

                // group row (customer header)
                if ($row.hasClass('report-grouping')) {
                    // finalize previous group: hide it if no visible rows
                    if (currentGroupRow && !groupHasVisibleRows) {
                        currentGroupRow.hide();
                    }

                    currentGroupRow = $row;
                    groupHasVisibleRows = false;

                    // tentatively hide group row; we’ll show it if any of its rows match
                    $row.hide();
                    return;
                }

                // invoice row
                var text = $row.text().toLowerCase();
                var match = text.indexOf(value) > -1;

                $row.toggle(match);
                if (match) {
                    groupHasVisibleRows = true;
                    if (currentGroupRow) {
                        currentGroupRow.show();
                    }
                }
            });

            // handle last group
            if (currentGroupRow && !groupHasVisibleRows) {
                currentGroupRow.hide();
            }
        });

    });
    
    function setOrderBy() {
        var orderBy = $('[aria-sort="ascending"], [aria-sort="descending"]').attr("data-order-by");
        var direction = $('[aria-sort="ascending"], [aria-sort="descending"]').attr('aria-sort');
        $("#print").attr("href", $("#print").attr("href") + "&orderBy=" + orderBy + "&direction=" + direction);
    }

    return vm;
});
